import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function Bonuses() {
  return <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-18" data-mp="au1rofrdu2f7">
      <div className="mx-auto max-w-6xl" data-id="element-19" data-mp="ftmwh6t8h4zu">
        <Eyebrow data-id="element-20" data-mp="fsbrj3o1xr75">
          <span className="inline-flex items-center gap-2" data-id="element-21" data-mp="frtkrd3rjukz">
            <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-22" data-mp="1tlufo18fris" /> 6 bonos — siempre incluidos
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-23" data-mp="5tvy2u1jy5uh">
          Además te llevás <span className="text-gold" data-id="element-24" data-mp="3o24w6539q3vw">6 bonos incluidos gratis</span>
        </SectionTitle>
        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="3t0g58dlqoad2">
          {bonuses.map(([number, icon, name, description, value]) => <article key={number} className="flex flex-col rounded-2xl border border-line bg-ink p-5" data-id="element-26" data-mp="1mb1it81zub7n">
              <div className="flex gap-3" data-id="element-27" data-mp="3idwotkx5belr">
                <span aria-hidden="true" className="text-3xl" data-id="element-28" data-mp="3icve5hk1ku4k">
                  {icon}
                </span>
                <div data-id="element-29" data-mp="3df3d9y1f5xo8">
                  <small className="font-bold uppercase tracking-[.12em] text-gold" data-id="element-30" data-mp="3r6qiwoh94ijo">
                    Bono {number}
                  </small>
                  <h3 className="font-bold text-white" data-id="element-31" data-mp="3n67smyv0bkjl">{name}</h3>
                </div>
              </div>
              <p className="my-4 flex-1 text-sm font-medium leading-relaxed text-zinc-300" data-id="element-32" data-mp="2zgde8cv1hnx8">
                {description}
              </p>
              <div className="mt-auto flex border-t border-line pt-4 text-sm font-bold" data-id="element-33" data-mp="2uiu0rf661f6c">
                <span className="text-zinc-500 line-through" data-id="element-34" data-mp="38e5x1qzyzdpd">Valor: {value}</span>
                <span className="ml-auto text-gold" data-id="element-35" data-mp="33fujp6agul2e">GRATIS</span>
              </div>
            </article>)}
        </div>
        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold/30 bg-gold/[0.06] p-6 text-center" data-id="element-36" data-mp="iqyhubzbel0a">
          <p className="font-medium text-zinc-300" data-id="element-37" data-mp="3cj6fm8uevimq">
            Valor total de bonos: <s className="font-bold text-zinc-500" data-id="element-38" data-mp="3cl94uqnqp7qe">$66.000 ARS</s>
          </p>
          <p className="mt-1 text-lg font-black text-white" data-id="element-39" data-mp="3hg6f20wr9n4v">
            Hoy van <span className="text-gold" data-id="element-40" data-mp="3lknwvujk1qd0">incluidos gratis</span> con tu Gimnasia Rítmica PRO.
          </p>
          <div className="mt-6" data-id="element-41" data-mp="3qhebsejmifwu">
            <Button href="#pricing" fullWidth className="text-xs md:text-sm" data-id="element-42" data-mp="3qgla3rziuglk">
              Sí, quiero mis 6 bonos gratis antes de que suba el precio →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}